import styled, { css, keyframes } from 'styled-components';
import { Box } from 'modules/Box';
import { Typography } from 'modules/Typography';
import { pxToRem } from 'modules/spacing';
import { themeGet, themeGetColor } from 'modules/tetrisTheme';
const BOTTOM_SPACING = themeGet('spacing.md');
export const Container = styled(Box) `
  position: fixed;
  left: 50%;
  bottom: 0;
  align-items: center;
  transform: translate(-50%, 0);
`;
function getTransitionCSS(state) {
    switch (state) {
        case 'visible':
            return css `
        transform: translate(0, 0);
      `;
        case 'entering':
        case 'leaving':
        case 'hidden':
            return css `
        transform: translate(0, calc(100% + ${BOTTOM_SPACING}));
      `;
        default:
            return undefined;
    }
}
export const Title = styled(Typography) ``;
export const Message = styled(Typography) ``;
function getAppearanceCSS(appearance) {
    switch (appearance) {
        case 'success':
            return css `
        ${Title} {
          color: ${themeGetColor('green.400')};
        }
      `;
        case 'danger':
            return css `
        ${Title} {
          color: ${themeGetColor('red.400')};
        }
      `;
        case 'info':
        default:
            return css `
        ${Title} {
          color: ${themeGetColor('gray.0')};
        }
      `;
    }
}
const backgroundBlurAnimation = keyframes `
  0% {
    backdrop-filter: blur(0);
  }
    
  100% {
    background-color: ${themeGetColor('brandPrimary.1000', 0.93)};
    backdrop-filter: blur(${pxToRem(20)});
  }
`;
const background = css `
  background-color: ${themeGetColor('brandPrimary.1000')};
  animation-name: ${backgroundBlurAnimation};
  animation-duration: 0.2s;
  animation-fill-mode: forwards;
  animation-delay: 0.2s;
`;
export const ToastContainer = styled.div `
  display: flex;
  position: fixed;
  flex-direction: column;
  bottom: ${BOTTOM_SPACING};
  gap: ${themeGet('spacing.lg')};
  min-width: 0;
  width: ${pxToRem(500)};
  padding: ${themeGet('spacing.xl')};
  ${background};
  ${(props) => getTransitionCSS(props.$transitionState)};
  ${(props) => getAppearanceCSS(props.$appearance)};
  transition: all 0.2s ease-in-out;
  box-shadow: ${themeGet('dropShadow.300')}, ${themeGet('dropShadow.400')};
  border-radius: ${themeGet('borderRadius.md')};

  ${Message} {
    color: ${themeGetColor('gray.100')};
  }
`;
